import { motion, useReducedMotion } from "framer-motion";
import { KineticLines, PrimaryButton, GhostButton, EASE } from "@/components/bits";
import { IMG, COMPANY } from "@/lib/data";

export const HomeHero = () => {
  const reduced = useReducedMotion();
  return (
    <section className="hero-reference relative overflow-hidden text-white" data-testid="hero-section">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-16 lg:py-20 grid grid-cols-1 lg:grid-cols-[1.15fr_0.85fr] gap-10 lg:gap-12 xl:gap-16 items-center" data-testid="hero-content-layout">
        <div className="min-w-0" data-testid="hero-copy">
          <motion.p initial={reduced ? false : { opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
            className="text-sm font-semibold uppercase text-brand-light mb-5" data-testid="hero-eyebrow">
            {COMPANY.name} · California freight brokerage
          </motion.p>
          <h1 className="w-full font-display font-semibold leading-[1.12] text-4xl sm:text-5xl xl:text-6xl" data-testid="hero-title">
            <KineticLines lines={["From pickup to delivery,", "we keep you informed."]} testid="hero-headline" />
          </h1>
          <motion.p initial={reduced ? false : { opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.4, ease: EASE }}
            className="mt-6 text-base sm:text-lg text-slate-200 leading-8 max-w-2xl" data-testid="hero-lead">
            From first pickup to final delivery, we coordinate your freight with vetted carriers, clear communication and a dedicated dispatch team.
          </motion.p>
          <motion.div initial={reduced ? false : { opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.55, ease: EASE }}
            className="mt-8 flex flex-col sm:flex-row gap-3">
            <PrimaryButton to="/quote" testid="hero-quote-cta">Get a Quote</PrimaryButton>
            <GhostButton to="/services" light testid="hero-services-cta">Explore Services</GhostButton>
          </motion.div>
        </div>
        <motion.div initial={reduced ? false : { opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.25, ease: EASE }}
          className="min-w-0 rounded-[28px] border border-white/10 bg-white/5 p-3 backdrop-blur" data-testid="hero-image-card">
          <div className="group overflow-hidden rounded-[20px] aspect-[16/11]">
            <img src={IMG.heroPort} alt="Container freight ship and tugboats" fetchPriority="high" decoding="async"
              className="img-zoom h-full w-full object-cover object-center" data-testid="hero-image" />
          </div>
          <div className="grid grid-cols-3 gap-3 sm:gap-4 px-2 pb-2 pt-5 text-slate-200" data-testid="hero-stats">
            {[["FTL", "Dedicated truckload coverage"], ["LTL", "Flexible less-than-truckload"], ["24/7", "Dispatch & shipment support"]].map(([title, label], index) => (
              <div key={title} data-testid={`hero-benefit-${index}`}>
                <p className="font-display text-xl sm:text-2xl font-semibold text-white">{title}</p>
                <p className="mt-1 text-xs sm:text-sm leading-relaxed text-slate-300">{label}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};